module.exports = __webpack_public_path__ + "assets/img/current-conductor.2e0203fc.png";